import { BRAND } from "../../constants/brand";
import React from "react";

import { Row, Col, Select, Button, Tag } from "antd";
import styles from "./index.module.scss";
import MainLayout from "../../components/layout/main-layout";
import bannerImage3 from "../../assets/imrpintbannernew.png";
import { useState } from "react";
import { Link } from "react-router-dom";

const blogData = [
  {
    id: 1,
    title: "Echo Chambers: The decline of diversity of thought",
    date: "29 May 2025",
    readTime: "10 mins read",
    category: "Lifestyle",
    image: "/Images/echoChambers.png",
    description:
      "As a mixed-race couple from very different socioeconomic and cultural...",
    slug: "echo-chambers-decline-diversity",
  },
  {
    id: 2,
    title: "Misogyny Online: Breaking the Cycle",
    date: "4 Jun 2025",
    readTime: "15 mins read",
    category: "Health",
    image: "/Images/MisogynyOnline.png",
    description:
      "As a mixed-race couple from very different socioeconomic and cultural...",
    slug: "misogyny-Online",
  },
  {
    id: 3,
    title:
      "What’s the Real Cost of Free? Why {BRAND.product} Chose a Subscription Model Over Ads",
    date: "6 Jun 2025",
    readTime: "12 mins read",
    category: "Trends",
    image: "/Images/RealCost.png",
    description:
      "Self-respect and dignity are core to who we are and how we teach our children to...",
    slug: "suscription-model",
  },
  {
    id: 4,
    title: "Trolling: We Must Draw a Line",
    date: "10 Jun 2025",
    readTime: "8 mins read",
    category: "Others",
    image: "/Images/Trolling.png",
    description:
      "As parents, we have experienced the pain of hearing our children come home...",
    slug: "trolling",
  },
];

const categories = ["All", "Lifestyle", "Health", "Trends", "Others"];

const Blogs = () => {
  const [filter, setFilter] = useState("All");
  const [sortOrder, setSortOrder] = useState("Oldest");

  const filteredBlogs = blogData
    .filter((blog) => filter === "All" || blog.category === filter)
    .sort((a, b) => {
      const aDate = new Date(a.date);
      const bDate = new Date(b.date);
      return sortOrder === "Oldest" ? aDate - bDate : bDate - aDate;
    });
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const [openModal, setOpenModal] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const showModal = (videoUrl) => {
    setActiveVideo(videoUrl);
    setOpenModal(true);
  };

  return (
    <MainLayout>
      <div
        id="herobanner"
        style={{
          background: `url(${bannerImage3}) no-repeat top center/cover`,
        }}
      >
        <div className={styles.heroBanner}>
          <div className={styles.overlay}>
            <h1>
              {BRAND.short} Time...{" "}
              <span className={styles.highlight}>Let's Talk</span>
            </h1>
          </div>
        </div>
      </div>

      <div className={styles.blogPage}>
        <div className={styles.filters}>
          <div className={styles.categories}>
            {categories.map((cat) => (
              <Button
                key={cat}
                type={filter === cat ? "primary" : "default"}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </Button>
            ))}
          </div>
          <div className={styles.sortDropdown}>
            <label>Sort by: </label>
            <Select
              value={sortOrder}
              onChange={(value) => setSortOrder(value)}
              style={{ width: 120 }}
              options={[
                { label: "Oldest", value: "Oldest" },
                { label: "Newest", value: "Newest" },
              ]}
            />
          </div>
        </div>

        <Row gutter={[24, 24]} className={styles.blogList}>
          {filteredBlogs.map((blog) => (
            <Col key={blog.id} xs={24} sm={24} md={12} lg={8} xl={6}>
              <a
                href={`/blogs/${blog.slug}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.blogCardLink}
              >
                <div className={styles.blogCard}>
                  <div
                    className={styles.image}
                    style={{ backgroundImage: `url(${blog.image})` }}
                  >
                    <Tag className={styles.categoryTag} color="blue">
                      {blog.category}
                    </Tag>
                  </div>
                  <div className={styles.content}>
                    <p className={styles.meta}>
                      {blog.date} • {blog.readTime}
                    </p>
                    <h3>{blog.title}</h3>
                    <p className={styles.description}>{blog.description}</p>
                  </div>
                </div>
              </a>
            </Col>
          ))}
        </Row>
      </div>
    </MainLayout>
  );
};

export default Blogs;
